import { createContext } from 'react';

const tooltipContext = createContext({ setTooltip: () => {} });

export { tooltipContext };
